import * as yup from 'yup'
import { getI18n } from 'react-i18next'

getI18n().setDefaultNamespace('login')

export const LoginSchema = yup.object().shape({
  email: yup.string().email(getI18n().t('email-valid')).required(getI18n().t('email-required')),
})
